/**
 *
 *
 *
 *
 *
 *
 */
import { o_global } from "@gr-common/body/namespaces";
import { asExport } from "@gr-exports/body/core";
import { noop } from "@gr-common/body/function";
/**
 *
 */
export const storage = /*           */ asExport(o_global, "globalStorage", noop);
